import { Output, EventEmitter, Input, OnInit, Component } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { OrientationService } from "../../../../../phf.service";

@Component({
    selector: 'orientation-container-window',
    templateUrl: './orientation-container.component.html',
    styleUrls: ['../../part-detail.component.scss']
})

export class OrientationContainerDialog implements OnInit {
    orientationContainerForm: FormGroup;
    part: any;
    public opened: boolean

    @Input()
    set data(editForm: FormGroup) {
        if (editForm) {
            this.part = editForm.value;
        }
    }

    @Output()
    save: EventEmitter<any> = new EventEmitter();
    @Output()
    close: EventEmitter<any> = new EventEmitter();

    constructor(
        private readonly formBuilder: FormBuilder,
        public readonly orientationService: OrientationService
    ) {
        this.orientationService.read();
    }

    ngOnInit() {
        this.orientationContainerForm = this.formBuilder.group(OrientationContainerForm);
        this.orientationContainerForm.reset(this.part);
    }

    closeWindow() {
        this.close.emit();
        this.opened = false;
    }

    // Builds and passes OrientationNote value to the OrientationContainer editForm in PartLoading tab
    onSave() {
        this.save.emit(this.orientationContainerForm.get('OrientationInContainer').value);
    }

    onClicked = (dataItem, orientation) => {
        const orientationDescription = this.orientationService.value.find(x => x.Id === dataItem);
        if (this.orientationContainerForm.get("OrientationInContainer").value) {
            const description = (orientationDescription ? ` ${orientationDescription.Description}` : '') + ` ${orientation},`;
            const orientationNote = this.orientationContainerForm.get("OrientationInContainer").value.concat(description);
            this.orientationContainerForm.get("OrientationInContainer").setValue(orientationNote);
        } else {
            this.orientationContainerForm.get("OrientationInContainer").setValue((orientationDescription ? orientationDescription.Description : '') + ` ${orientation},`);
        }
    }
}


const OrientationContainerForm = {
    OrientationInContainer: []
}


